import React from 'react';
export const useElement = props => {
  const {
    // cy,
    element,
    contextRef,
    config = {}
  } = props;
  const {
    renderEvents = []
  } = config; // EventListeners

  React.useEffect(() => {
    renderEvents.forEach(eventName => {
      element.on(eventName, () => {
        var _contextRef$current, _contextRef$current$r;

        (_contextRef$current = contextRef.current) === null || _contextRef$current === void 0 ? void 0 : (_contextRef$current$r = _contextRef$current.render) === null || _contextRef$current$r === void 0 ? void 0 : _contextRef$current$r.call(_contextRef$current);
      });
    });
    return () => {
      renderEvents.forEach(eventName => {
        element.off(eventName);
      });
    };
  }, [element, renderEvents]);
  return {};
};